export const routes = {
    home: { url: "/#top" },
    mieten: { url: "/mieten" },
    kaufen: { url: "/kaufen" },
    anbaugeraete_zubehoer: { url: "/anbaugeraete-zubehoer" },
    kontakt: { url: "/#kontakt" },
    impressum: { url: "/impressum" },
    datenschutz: { url: "/datenschutz" },
    disclaimer: { url: "/disclaimer" },
};
